// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7aff761","455":"4782b91c","977":"ef0e1caf"}[chunkId] + ".chunk.js";
};